<template lang="pug">
  div
    b-alert(:show='true' v-if="this.mensaje != ''" :variant='tipo')
      | {{mensaje}}
    b-form(@submit='onSubmit' @reset='onReset')
      b-card(v-if="this.add == true")
        template(#header='')
          h6.mb-0 Presentar Respuesta
        b-card-text
          div
            .form-group.row
              b-form-group#input-group-1.col-sm-1.col-form-label(label='RUC:' label-for='input-ruc')
              .col-sm-3
                b-form-input#input-ruc(v-model='propuesta.ruc' @blur.native ='getDatosProveedor(propuesta.ruc)')
              span.ml-auto(style='color: red;') *
              b-form-group#input-group-2.col-form-label(label='Razon Social:' label-for='input-razon-social')
              .col-sm-4
                b-form-input#input-razon-social(v-model='propuesta.razon_social' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Correo:' label-for='input-correo')
              .col-sm-7
                b-form-input#input-correo(v-model='propuesta.email'   type='email' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Respuesta:' label-for='input-propuesta')
              .col-sm-11
                vue-editor(
                  v-model='propuesta.descripcion_propuesta'
                  :editorToolbar="customToolbar"
                )
            br
            .form-group.row()
              b-form-group#input-group-12.col-sm-2.col-form-label(label='Adjuntar Documento:' label-for='input-documento')
              .col-sm
                .row
                  .col
                    b-form-file#file-default(
                      v-model= 'archivo'
                      placeholder="Seleccionar Archivo"
                      accept=".zip, .rar, .tar, application/pdf,application/x-zip-compressed"
                    )
                  .col
                    button.btn.btn-primary.border-top(
                      :disabled='this.archivo == null || cargaArchivo '
                      v-if='!disabled'
                      @click.prevent='cargarArchivo()'
                    ) {{cargaArchivo ? 'Subiendo Archivo...' : 'Subir Archivo'}}

            table.table.table-bordered.table-condensed.table-striped.table-hover(v-if = 'archivoList.length > 0')
              thead
                tr
                  th.text-center.w-25 Nombre
                  th.text-center.w-25 Fecha Adjunto
                  th.text-center.w-25 Acciones
              tbody()
                tr( v-for='(row,index) in archivoList')
                  td.text-center {{row.name}}
                  td.text-center {{row.lastModifiedDate ? convertDate(row.lastModifiedDate) : row.fechaArchivo}}
                  td.text-center
                    .btn-group
                      b-dropdown.m-md-1(text='Acciones')
                        b-dropdown-item(@click.prevent='obtenerArchivo(row)') Descargar
                        b-dropdown-item(@click.prevent='borrarArchivo(row,index)') Borrar

            div.float-right
              button.btn.btn-primary(type='submit' v-if='!disabled') Grabar


</template>

<script>

import {VueEditor} from "vue2-editor";

import {HTTP} from "../http";
import functions from '../mixins/functions'


export default {
  name: "PresentarPropuesta",
  mixins: [functions],
  components: {
    VueEditor
  },

  data() {
    return {
      add: Boolean,
      propuesta: {},
      controlDuplicado: {},
      solicitudInformacion : [],
      listaPropuestas: {},
      archivoList: [],
      archivo: null,
      descripcionPropuesta : "",
      modalShow: false,
      cargaArchivo: false,
      datosProveedor: {},
      grabarBorrador: Boolean,
      rfi_id: null,
      date: null,
      disabled: Boolean,

      requiredFields: [
        'descripcion_propuesta'
      ],


      customToolbar: [[{
        header: [false, 1, 2, 3, 4, 5, 6]
      }], ["bold", "italic", "underline", "strike"], // toggled buttons
        [{
          align: ""
        }, {
          align: "center"
        }, {
          align: "right"
        }, {
          align: "justify"
        }],[{
          list: "ordered"
        }, {
          list: "bullet"
        }, {
          list: "check"
        }], [{
          indent: "-1"
        }, {
          indent: "+1"
        }], // outdent/indent
        [{
          color: []
        }, {
          background: []
        }], // dropdown with defaults from theme
        ["clean"] // remove formatting button
      ],

    }
  },
  async created(){
    this.activeSpinner();


    this.add = true;
    this.disabled = false;

    this.grabarBorrador= false;
    //Se recibe el ID del RFI al que corresponde la respuesta, desde la peticion enviada desde el portal publico
    this.rfi_id = encodeURIComponent(this.$route.query.id);

    this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.rfi_id}})).data
    this.date=this._concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'));

    if(this.date>this.solicitudInformacion.recepcion_propuesta_fecha_fin){
      this.tipo = 'danger'
      this.mensaje = "Esta Solicitud de Informacion no puede recibir respuestas porque ya ha alcanzado su fecha limite de recepcion de respuestas."
      this.disabled = true;
    }

    if(this.solicitudInformacion.estado_codigo == "FINALIZADO" || this.solicitudInformacion.estado_codigo == "CANCELADO"){
      this.tipo = 'danger'
      this.mensaje = "Esta Solicitud de Informacion no puede recibir respuestas porque ha sido Cancelada o Finalizada."
      this.disabled = true;
    }
    this.desactiveSpinner();

    console.log(this.solicitudInformacion)
  },

  methods: {
    onSubmit(event) {
      this.presentar(this.propuesta)
      event.preventDefault()
    },
    onReset(event) {
      event.preventDefault()
      this.volver();
      // Trick to reset/clear native browser form validation state
    },

    getDatosProveedor:async function(ruc) {
      this.propuesta.razon_social = ""
      this.propuesta.email = ""
      this.propuesta.proveedor_id = null

      this.datosProveedor = (await HTTP.get('/invitado/getProveedor/'+ruc)).data
      this.propuesta.razon_social = this.datosProveedor.razon_social
      this.propuesta.email = this.datosProveedor.email
      this.propuesta.proveedor_id = this.datosProveedor.id

      this.add = false
      this.$nextTick(()=>{
        this.add = true
      })
    },

    presentar: async function (instance) {
      this.controlDuplicado.email = instance.email
      this.controlDuplicado.ruc = instance.ruc
      this.controlDuplicado.rfi_id = this.rfi_id

      instance.rfi_id = this.rfi_id;
      instance.estado_codigo = "BORRADOR"
      if(!this._checkRequired(instance, this.requiredFields)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la Respuesta'});

      } else {
        instance.archivos = []
        this.archivoList.forEach(archivo => {
          let fileToSave = {
            nombre_archivo: archivo.name,
            type: archivo.type,
            size: archivo.size,
            tmpFilePath: archivo.tmpFilePath
          }
          instance.archivos.push(fileToSave)
        })
        try {
          const data = await (HTTP.post('/respuesta/create', instance));
          this.$router.push({path: "/respuesta/modificar", query:{id: data.data}});
          this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha grabado la Respuesta'});
        } catch (error) {
          console.log(error);
          this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al grabar la Respuesta. '+ error.response.data});
          window.scrollTo(0, 0);
        }
      }
    },
    convertDate: function(fecha) {
      if(fecha){
        let date = JSON.stringify(fecha)
        date = date.slice(1,11)
        return date
      }
      return null
    },
    async getArchivos() {
      this.archivoList = (await HTTP.get('/archivo/listar', {params: {solicitudId: this.id}})).data;
    },
    cargarArchivo: function () {
      let formData = new FormData()
      formData.append('archivo', this.archivo)
      this.cargaArchivo = true;
      HTTP.post('/archivo/subir', formData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
      }).then(result => {
        this.archivo.tmpFilePath = result.data.tmpFilePath
        this.archivoList.push(this.archivo)
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo recibido correctamente'});
        this.archivo = null
      }).catch(error => {
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al subir el archivo. ' + error.response.data});
      }).finally(() => {
        this.cargaArchivo = false;
      })
    },
    obtenerArchivo(instance) {
      console.log(instance.documento_id)
      HTTP.get('/archivo/obtenerPropuestaArchivo', {params: {documentoId: instance.documento_id}, responseType: 'blob'})
          .then(result => {
            this.handleResponseArchivo(result.data, instance.nombre_archivo)
          })
          .catch(error => {
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Obtener el archivo. ' + error.response.data});
          })
    },
    borrarArchivo: function (instance,index) {
      // this.$delete(this.archivoList, index)
      this.archivoList.splice(index,1)
      window.scrollTo(0,0);
      this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo eliminado correctamente'});

    },
    handleResponseArchivo(blobData, name) {
      let fileURL = window.URL.createObjectURL(blobData);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  }
}
</script>

<style scoped>

</style>
